import React, { useState } from 'react';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { AbsenceReportLine, downloadAbsenceReport, toExcelDownload } from '@features/reporting/services/ReportingService';
import { firstBy } from "thenby";
import { Moment } from "moment";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function DownloadDetailedAbsenceReportButton(props: Props) {
  const {fromDate, toDate, disabled} = props;
  const [loading, setLoading] = useState(false);

  const downloadDetailedReport = async () => {
    try {
      setLoading(true);
      const reportData: AbsenceReportLine[] = (await downloadAbsenceReport(fromDate, toDate));
      reportData.sort(firstBy('lastName').thenBy('firstName').thenBy('date'))
      toExcelDownload(reportData, `Absence report`);
    } finally {
      setLoading(false);
    }
  }

  return (
    <OutlineButton size={ButtonSize.Medium}
                   disabled={disabled || loading}
                   text="reports-page.holidays-report.report"
                   click={downloadDetailedReport} />
  )
}

interface Props {
  fromDate: Moment;
  toDate: Moment;
  disabled: boolean;
}
